import { HERITAGE_PHOTOS, MEDIA } from "../lib/constants";

export const Gallery = () => {
  // Curated gallery — only real photos: 4 heritage (workforce removed) + 1 real Liebherr port photo (uncaptioned)
  const items = [
    { url: HERITAGE_PHOTOS[0].url, caption: HERITAGE_PHOTOS[0].caption, era: "Heritage", span: "row-span-2", position: "75% center" },
    { url: MEDIA.gallery[0], caption: "", era: "Operations", span: "" },
    { url: HERITAGE_PHOTOS[1].url, caption: HERITAGE_PHOTOS[1].caption, era: "Heritage", span: "col-span-2" },
    { url: HERITAGE_PHOTOS[2].url, caption: HERITAGE_PHOTOS[2].caption, era: "Heritage", span: "" },
    { url: HERITAGE_PHOTOS[3].url, caption: HERITAGE_PHOTOS[3].caption, era: "Heritage", span: "col-span-2" },
  ];

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-[#061426] py-20 md:py-32 overflow-hidden grain"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14 reveal">
          <div className="flex items-center gap-4">
            <span className="gold-line" />
            <h2 className="font-sans text-[#C8A24A] uppercase text-3xl md:text-4xl lg:text-5xl tracking-widest-2 font-semibold">
              Gallery
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[200px] md:auto-rows-[260px] gap-3 md:gap-4">
          {items.map((it, i) => (
            <figure
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`relative overflow-hidden bg-[#0B2545] group reveal ${it.span}`}
              style={{ transitionDelay: `${(i % 6) * 60}ms` }}
            >
              <img
                src={it.url}
                alt={it.caption}
                style={it.position ? { objectPosition: it.position } : undefined}
                className={`w-full h-full object-cover transition-transform duration-[1100ms] group-hover:scale-110 ${
                  it.era === "Heritage" ? "grayscale-[15%] sepia-[10%]" : ""
                }`}
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#061426] via-[#061426]/30 to-transparent opacity-70 group-hover:opacity-95 transition-opacity duration-500" />
              {it.caption && (
                <figcaption className="absolute inset-x-0 bottom-0 p-4 md:p-5 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                  <span className="font-sans text-[10px] tracking-widest-2 uppercase text-[#C8A24A]">
                    {it.era}
                  </span>
                  <p className="font-serif italic text-white text-sm md:text-base mt-1 leading-tight">
                    {it.caption}
                  </p>
                </figcaption>
              )}
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
